import React from "react";

const ArticleSchema = ({ schema }) => {
    if (!schema) return null;

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(schema),
            }}
        />
    );
};

export default ArticleSchema;